import React from 'react';
import { NavLink } from 'react-router-dom';
import { FiShield, FiClock, FiAlertTriangle } from 'react-icons/fi';
import { Icon } from '../ui/Icon';

export function Footer() {
  const complianceLinks = [
    { key: 'anj', label: 'ANJ', src: '/images/footer/ANJ.webp', href: 'https://anj.fr/' },
    {
      key: 'jouns',
      label: 'Jouons Responsable',
      src: '/images/footer/jouns.webp',
      href: 'https://www.hippodromesenfete.fr/jouons-responsable/',
    },
    {
      key: 'arjel',
      label: 'ARJEL (archive)',
      src: '/images/footer/ARJEL.webp',
      href: 'https://www.data.gouv.fr/en/organizations/autorite-de-regulation-des-jeux-en-ligne-arjel/',
    },
    {
      key: 'mediater',
      label: 'Médiateur des jeux en ligne',
      src: '/images/footer/mediateur.webp',
      href: 'https://mediateurdesjeuxenligne.fr/',
    },
    { key: 'begamble', label: 'GambleAware', src: '/images/footer/gambleaware.webp', href: 'https://www.gambleaware.org/' },
  ] as const;

  return (
    <footer className="mt-16 border-t border-white/10 bg-zinc-950/70">
      <div className="lbf-container py-12">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-3">
              <img
                src="/images/logo.webp"
                width={34}
                height={34}
                alt="LuckyBetFR"
                className="h-9 w-9 rounded-xl border border-white/10 bg-white/5"
                loading="lazy"
                decoding="async"
              />
              <div>
                <div className="text-sm font-extrabold tracking-wide">LuckyBetFR</div>
                <div className="text-xs text-zinc-300/80">Comparateur d’offres • France</div>
              </div>
            </div>
            <p className="mt-4 text-sm text-zinc-300/80">
              Ici, on compare les offres comme un parieur exigeant: conditions, retraits, cotes et vrais “petits
              caractères”. Pas de poudre aux yeux — juste des choix plus nets.
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              <span className="lbf-badge">
                <Icon icon={FiShield} aria-hidden="true" />
                Avis structurés
              </span>
              <span className="lbf-badge">
                <Icon icon={FiClock} aria-hidden="true" />
                Mise à jour régulière
              </span>
              <span className="lbf-badge">
                <Icon icon={FiAlertTriangle} aria-hidden="true" />
                Jeu responsable
              </span>
            </div>
          </div>

          <div className="grid gap-3 text-sm">
            <div className="text-xs font-bold uppercase tracking-wider text-zinc-300/70">Pages</div>
            <NavLink to="/offres" className="text-white/85 hover:text-white">
              Offres & avis
            </NavLink>
            <NavLink to="/comparatif-offres" className="text-white/85 hover:text-white">
              Comparatif
            </NavLink>
            <NavLink to="/faq" className="text-white/85 hover:text-white">
              FAQ
            </NavLink>
            <NavLink to="/a-propos" className="text-white/85 hover:text-white">
              À propos
            </NavLink>
          </div>

          <div className="grid gap-3 text-sm">
            <div className="text-xs font-bold uppercase tracking-wider text-zinc-300/70">Conformité</div>
            <NavLink to="/politique-confidentialite" className="text-white/85 hover:text-white">
              Politique de confidentialité
            </NavLink>
            <NavLink to="/politique-cookies" className="text-white/85 hover:text-white">
              Politique cookies
            </NavLink>
            <NavLink to="/conditions" className="text-white/85 hover:text-white">
              Conditions d’utilisation
            </NavLink>

            <div className="mt-4 grid grid-cols-3 gap-3 opacity-95">
              {complianceLinks.map((x) => (
                <a
                  key={x.key}
                  href={x.href}
                  target="_blank"
                  rel="noreferrer"
                  className="group rounded-lg border border-white/10 bg-white/5 p-2 transition hover:bg-white/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-fuchsia-400/70"
                  aria-label={x.label}
                  title={x.label}
                >
                  <img
                    src={x.src}
                    alt={x.label}
                    className="h-10 w-full object-contain"
                    loading="lazy"
                    decoding="async"
                  />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 rounded-2xl border border-white/10 bg-white/5 p-4 text-xs text-zinc-200/80">
          <div className="font-semibold text-white/90">18+ • Jeu responsable</div>
          <p className="mt-2">
            Les paris sportifs comportent des risques financiers. Fixez un budget, évitez de “chasser” vos pertes et
            faites des pauses. LuckyBetFR est un site d’information — pas un opérateur de jeu.
          </p>
        </div>

        <div className="mt-8 flex flex-col gap-2 text-xs text-zinc-400 sm:flex-row sm:items-center sm:justify-between">
          <div>© {new Date().getFullYear()} LuckyBetFR</div>
          <div className="text-zinc-400/80">Performance-first • UI dark • Animations légères</div>
        </div>
      </div>
    </footer>
  );
}


